import NotImplementedError from "./NotImplementedError.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class Grouping {

    /**
     *
     * @param transaction
     * @returns {string}
     * @protected
     */
    _keyFunc(transaction) {
        throw new NotImplementedError();
    }

    /**
     *
     * @param {string} key
     * @returns {string}
     * @protected
     */
    _follows(key) {
        throw new NotImplementedError();
    }

    /**
     *
     * @param transactions {Transaction[]}
     * @returns {Map<string, Transaction[]>}
     */
    createGroups(transactions) {
        let groups = new Map();
        for (let transaction of transactions) {
            let key = this._keyFunc(transaction);
            let list = groups.get(key);
            if (list === undefined) {
                list = [];
                groups.set(key, list);
            }
            list.push(transaction);
        }

        if (groups.size > 2) {
            this._generateEmptyGroups(groups);
        }

        return groups;
    }

    /**
     *
     * @param {Map<string, Transaction[]>} groups
     * @protected
     */
    _generateEmptyGroups(groups) {
        let keys = Array.from(groups.keys()).sort();
        for (let i = 0; i < keys.length - 1; i++) {
            let current = keys[i];
            let next = keys[i + 1];

            const LIMIT = 10_000;  // max number of generated groups...
            for (let j = 0; j < LIMIT; j++) {
                let expected = this._follows(current);
                if (expected === next) {
                    // correct
                    break;
                } else {
                    if (!groups.has(expected)) {
                        groups.set(expected, []);
                        current = expected;
                    } else {
                        // the follow method does not work well here - for example 53. week
                        break;
                    }
                }
            }
        }
    }
}
